module.exports = __webpack_public_path__ + "static/img/ban3.c16e5ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ban3.jpg
// module id = GTXq
// module chunks = 1